import { render, staticRenderFns } from "./GlobalConfigs.vue?vue&type=template&id=02bd5c18&"
import script from "./GlobalConfigs.vue?vue&type=script&lang=js&"
export * from "./GlobalConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports